import React from 'react';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const ViewDashboardIcon = ({ toolTipText = 'View Dashboard' }) => (
  <Icon tooltip={ toolTipText } iconObj={faChartLine} />
);

export default ViewDashboardIcon;